<template>
	<div>
		<CommonHeader :setOrden="true" :showIcon="true" :showBackButton="true" :title="$t('changePassword')"></CommonHeader>
		<div class="Content">
			<p>{{$t('changePassword')}}</p>

			<form class="form-crear">
				<div class="form-group">
					<div>
						<label>{{$t('currentPassword')}} </label>
						<div class="contenedor">
							<input type="password" class="texto" v-model="formData.oldPass"/>
						</div>
						<span v-if="formErrors.oldPass" class="error">{{ $t('passwordError') }}</span>
					</div>
				</div>
				<div class="form-group">
					<div>
						<label>{{$t('newPassword')}} </label>
						<div class="contenedor">
							<input 
								:type="showPassword ? 'text' : 'password'" 
								class="texto" 
								v-model="formData.newPass"
							/>
							<input
								class="imagen"
								type="image"
								src="https://pngimage.net/wp-content/uploads/2018/06/icono-ojo-png-5.png"
								width="20"
								height="15"
								@click.prevent="() => (showPassword = !showPassword)"
							/>							
						</div>
						<span v-if="formErrors.newPass" class="error">{{ $t('passwordError') }}</span>
					</div>
				</div>
				<div class="form-group">
					<div>
						<label>{{$t('repeatNewPassword')}} </label>
						<div class="contenedor">
							<input 
								:type="showPassword2 ? 'text' : 'password'" 
								class="texto"
								v-model="formData.newPass2"
							/>
							<input
								class="imagen"
								type="image"
								src="https://pngimage.net/wp-content/uploads/2018/06/icono-ojo-png-5.png"
								width="20"
								height="15"								
								@click.prevent="() => (showPassword2 = !showPassword2)"
							/>
						</div>
						<span v-if="formErrors.newPass2 || firebaseError" class="error"> {{firebaseError ? error : $t('passwordError') }}</span>
					</div>
				</div>
			</form>
			<AjaxButton
				class="final-button"
				:loading="loading"
				:text="$t('updateData')"
				@click="changePass()"
			></AjaxButton>
		</div>
	</div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/components/CommonHeader.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import auth from '@/config/auth'
import firebase from 'firebase/app';

@Component({
	components: {
		CommonHeader,
		AjaxButton,
	},
})
export default class ChangePassword extends Vue {

	loading = false
	showPassword = false
	showPassword2 = false
	currUser = this.$store.state.user
	error = ""
	firebaseError = false

	formData = {
		oldPass: "",
		newPass: "",
		newPass2: ""
	}

	formErrors = {
		oldPass: false,
		newPass: false,
		newPass2: false
	}

	async changePass(){
		if(!this.validForm()) return
		const user = await auth.currentUser
		const credential = await firebase.auth.EmailAuthProvider.credential(this.currUser.email, this.formData.oldPass)
		try {
			await user.reauthenticateWithCredential(credential)
			await user.updatePassword(this.formData.newPass)
			this.$router.push('/profile')
		} catch (e) {	
			switch(e.code){
				case ('auth/weak-password'):
					this.firebaseError = true
					this.error = this.$t('weakPassword').toString();
					break;
			}
		}
	}

	validForm(){
		this.formErrors = {oldPass: false, newPass: false, newPass2: false}
		if(!this.formData.oldPass) this.formErrors.oldPass = true
		if(!this.formData.newPass) this.formErrors.newPass = true
		if(!this.formData.newPass2) this.formErrors.newPass2 = true
		if(this.formData.newPass !== this.formData.newPass2) this.formErrors.newPass2 = true
		for (const error of Object.values(this.formErrors)) {
			if (error == true) return false;
		}
		return true
	}
}
</script>
<style lang="scss" scoped>
.CommonHeader {
	text-transform: uppercase;
}

.Content {
	padding: 1em;

	.form-group {
		margin: 1em 0;
		label {
			font-size: 1em;
			color: #000;
			margin-bottom: 0.4em;
		}

		div.contenedor {
			border: 1px solid #d7d7d7;
			margin: 0.4em 0 0;
			padding: 0;
			border-radius: 7px;
		}
		input.texto {
			border: 0px;
			width: 85%;
			position: relative;
			background: transparent;
			outline: none;
			padding: 0.8em 0.8em 0.8em 10px;
		}
		input.texto ::-webkit-input-placeholder {
			color: rgba(117, 112, 112, 1);
			font-size: 1.2em;
		}
		input.imagen {
			width: 20px;
			border: 0px;
			position: relative;
			top: 1px;
		}

		.error {
			font-size: 12px;
			color: red;
			margin: auto;
		}
	}
}
p {
	color: rgba(254, 202, 56, 1);
	font-weight: 700;
	font-size: 1.8em;
}
.final-button {
	font-weight: 500;
	font-size: 1.15em;
	color: white;
	margin: 1em 0;
}
</style>